@if (sidenavConfig$ | async; as sidenavConfig) {
  <mat-sidenav-container
    (swipeleft)="close()">
    @if (user.authenticated) {
      <mat-sidenav
        [mode]="sidenavConfig.mode"
        [opened]="sidenavConfig.opened">
        <mat-nav-list>
          <mat-list-item class="profile no-list-item-highlight"
            (click)="copyTokenToClipBoard()">
            <zah-avatar matListItemAvatar [name]="user.getUsername()"></zah-avatar>
            <div matListItemTitle>{{user.getUsername()}}</div>
            <div matListItemLine class="mat-small">{{user.getRolesString()}}</div>
          </mat-list-item>
          <mat-divider></mat-divider>
          <div mat-subheader>Ga naar</div>
          <mat-list-item
            *zahRequiresOneOfRoles="[Role.ADMIN]"
            (click)="navigateTo('/thuisverzorgers', sidenavConfig)"
            [ngClass]="{'active': isUrlActive('/thuisverzorgers')}">
            <mat-icon matListItemIcon>person</mat-icon>
            <div matListItemTitle>Thuisverzorgers</div>
          </mat-list-item>
          <mat-list-item
            *zahRequiresOneOfRoles="[Role.ADMIN]"
            (click)="navigateTo('/regioverantwoordelijken', sidenavConfig)"
            [ngClass]="{'active': isUrlActive('/regioverantwoordelijken')}">
            <mat-icon matListItemIcon>groups</mat-icon>
            <div matListItemTitle>Regioverantwoordelijken</div>
          </mat-list-item>
          <mat-list-item
            *zahRequiresOneOfRoles="[Role.ADMIN]"
            (click)="navigateTo('/therapeuten', sidenavConfig)"
            [ngClass]="{'active': isUrlActive('/therapeuten')}">
            <mat-icon matListItemIcon>supervisor_account</mat-icon>
            <div matListItemTitle>Therapeuten</div>
          </mat-list-item>
          <mat-list-item
            *zahRequiresOneOfRoles="[Role.SUPERADMIN, Role.ADMIN]"
            (click)="navigateTo('/admins', sidenavConfig)"
            [ngClass]="{'active': isUrlActive('/admins')}">
            <mat-icon matListItemIcon>admin_panel_settings</mat-icon>
            <div matListItemTitle>Admins</div>
          </mat-list-item>
          <mat-list-item
            *zahRequiresOneOfRoles="[Role.REGIOVERANTWOORDELIJKE]"
            (click)="navigateTo('/activiteiten', sidenavConfig)"
            [ngClass]="{'active': isUrlActive('/activiteiten')}">
            <mat-icon matListItemIcon fontSet="material-icons-outlined">fact_check</mat-icon>
            <div matListItemTitle>Activiteit</div>
          </mat-list-item>
          <mat-list-item
            *zahRequiresOneOfRoles="[Role.REGIOVERANTWOORDELIJKE]"
            (click)="navigateTo('/clienten', sidenavConfig)"
            [ngClass]="{'active': isUrlActive('/clienten')}">
            <mat-icon matListItemIcon>face</mat-icon>
            <div matListItemTitle>Cliënten</div>
          </mat-list-item>
          <mat-list-item
            *zahRequiresOneOfRoles="[Role.REGIOVERANTWOORDELIJKE]"
            (click)="navigateTo('/exports', sidenavConfig)"
            [ngClass]="{'active': isUrlActive('/exports')}">
            <mat-icon matListItemIcon fontSet="material-icons-outlined">cloud_download</mat-icon>
            <div matListItemTitle>Exports</div>
          </mat-list-item>
          <mat-list-item
            *zahRequiresOneOfRoles="[Role.THERAPEUT]"
            (click)="navigateTo('/clienten/zoeken', sidenavConfig)"
            [ngClass]="{'active': isUrlActive('/clienten')}">
            <mat-icon matListItemIcon>face</mat-icon>
            <div matListItemTitle>Cliënten</div>
          </mat-list-item>
          <mat-list-item (click)="logout()">
            <mat-icon matListItemIcon>logout</mat-icon>
            <div matListItemTitle>Afmelden</div>
          </mat-list-item>
        </mat-nav-list>
        <img class="logo" [src]="logo" alt="Zorgleuven logo">
      </mat-sidenav>
    }
    <mat-sidenav-content (swiperight)="open()">
      <ng-content></ng-content>
    </mat-sidenav-content>
  </mat-sidenav-container>
}
